/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import { FormTransformations } from "../../../types/ProductService/ProductService";
import abstractLitigationCaseTransformations from "./abstractLitigationCaseTransformations";

const trafficAccidentTransformations: FormTransformations = {
  dateFields: [...abstractLitigationCaseTransformations.dateFields!, { path: "accidentDate", type: "date" }],
  numberFields: abstractLitigationCaseTransformations.numberFields,
  timeFields: [...abstractLitigationCaseTransformations.timeFields!, "accidentTime"],
  floatFields: [...abstractLitigationCaseTransformations.floatFields!, "costReal", "costEstimate"],
  ibanFields: abstractLitigationCaseTransformations.ibanFields,
  extendedSelectFields: ["claimsForDamages"],
  entityIriFields: ["opposingCarLiabilityInsurance.organization"],
};
export default trafficAccidentTransformations;
